export enum OrderControl {
    EASYMARINE = 'EASYMARINE',
    THIRD_PARTY = 'THIRD_PARTY',
    THIRD_PARTY_IMPORT = 'THIRD_PARTY_IMPORT'
}
